import React, { useState, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';

import moment from 'moment';

import { format, subDays, setHours, setMinutes, setSeconds } from 'date-fns';

import { isEmpty } from 'lodash';

import { Report, ListTransfer } from '~/components';
import { DateTime, Autocomplete, RadioGroup } from '~/components/Form';

import { GFO } from '~/constants/perfil';

import * as Yup from 'yup';
import { t, parseDateString } from '~/helpers';

function Reldespesaaquisicaocombustivel() {
  const [open, setOpen] = useState(true);

  //NOVOS CAMPOS
  const [valueProduto, setValueProduto] = React.useState(0);
  const [inputValueProduto, setInputValueProduto] = React.useState('');

  const [orgaos, setOrgaos] = useState([]);

  const cells = useMemo(
    () => [
      { id: 'orga_nome', label: 'Órgão' },
      { id: 'orga_codigo', label: 'Código' },
    ],
    []
  );


  // const start = moment()
  //   .subtract({ day: 7 })
  //   .set({ hour: 0, minute: 0, second: 0 });

  // const end = moment().set({ hour: 23, minute: 59, second: 59 });

  const datahorainicial = useMemo(
    () =>
      format(
        setSeconds(setMinutes(setHours(subDays(new Date(), 7), 0), 0), 0),
        'dd/MM/yyyy HH:mm:ss'
      ),
    []
  );

  const datahorafinal = useMemo(
    () =>
      format(
        setSeconds(setMinutes(setHours(new Date(), 23), 59), 59),
        'dd/MM/yyyy HH:mm:ss'
      ),
    []
  );




  const { profile } = useSelector((state) => state.user);

  async function handleValidate(param) {
    try {
      const schema = Yup.object().shape({
        // datahorainicial: Yup.string().required(
        //   t('s.geral.validacao.campoobrigatorio')
        // ),
        // datahorafinal: Yup.string().required(
        //   t('s.geral.validacao.campoobrigatorio')
        // ),

        datahorainicial: Yup.date()
          .typeError(t('s.geral.validacao.campoobrigatorio'))
          .transform((_, value) => parseDateString(value))
          .required(t('s.geral.validacao.campoobrigatorio')),
        datahorafinal: Yup.date()
          .typeError(t('s.geral.validacao.campoobrigatorio'))
          .transform((_, value) => parseDateString(value))
          .required(t('s.geral.validacao.campoobrigatorio'))
          .max(
            datahorafinal,
            `A data não pode ser superior a ${datahorafinal}`
          )
          .min(
            Yup.ref('datahorainicial'),
            'A data não pode ser inferior a Data inicial'
          ),

        prod_codigo: Yup.string().nullable(),
      });

      await schema.validate(param, {
        abortEarly: false,
      });

      if (isEmpty(orgaos))
        throw 'Por favor, selecione ao menos um órgão antes de enviar.';


    } catch (err) {

      const form = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          form[error.path] = error.message.replace(`${error.path} `, '');
        });

        throw { form };
      } else {
        throw err;
      }

      // const form = {};

      // if (err instanceof Yup.ValidationError) {
      //   err.inner.forEach((error) => {
      //     form[error.path] = error.message.replace(`${error.path} `, '');
      //   });

      //   throw { form };
      // }
    }
  }

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      if (profile.glousuariotipo === GFO) {
      }
    }
    return function cleanup() {
      mounted = false;
    };
  }, [profile]);

  function handleSerializeForm(params) {
    const { datahorainicial, datahorafinal } = params;

    let produto = '';
    if (params.prod_codigo) {
      produto = params.prod_codigo;
    } else {
      produto = '';
    }

    let produtostr = '';
    if (params.prod_descricao) {
      produtostr = params.prod_descricao;
    } else {
      produtostr = '';
    }

    let codigos = [];

    orgaos.map((orgao) => {
      codigos.push(orgao.orga_codigo);
    });

    let orgao = codigos;

    let tipo = 'pdf';
    if (params.formato) {
      tipo = params.formato;
    } else {
      tipo = 'pdf';
    }

    return {
      ...params,
      datahorainicial,
      datahorafinal,
      produto,
      produtostr,
      orgao,
      tipo,
    };
  }

  return (
    <Report
      open={open}
      onClose={() => setOpen(false)}
      title="Despesa com Aquisição de Combustível"
      relatorio="despesaaquisicaocombustivel"
      maxWidth="md"
      validate={(param) => handleValidate(param)}
      serialize={(param) => handleSerializeForm(param)}
      initials={{
        datahorainicial,
        datahorafinal,
        // datahorainicial: start.format('DD/MM/YYYY HH:mm:ss'),
        // datahorafinal: end.format('DD/MM/YYYY HH:mm:ss'),
      }}
    >
      <DateTime
        label="Data Inicial"
        name="datahorainicial"
        serialize={(value) =>
          value.set({ second: 0 }).format('DD/MM/YYYY HH:mm:ss')
        }
        time
        disableFuture
      />

      <DateTime
        label="Data Final"
        name="datahorafinal"
        serialize={(value) =>
          value.set({ second: 0 }).format('DD/MM/YYYY HH:mm:ss')
        }
        time
        disableFuture
      />

      <Autocomplete
        name="prod_codigo"
        label="prod_descricao"
        title="Produto"
        id="prod_codigo"
        url="produtos"
        unique="prod_codigo"
        value={valueProduto}
        inputValue={inputValueProduto}
        onChange={(event, newValue) => {
          setValueProduto(newValue);
        }}
        onInputChange={(event, newInputValueProtudo) => {
          setInputValueProduto(newInputValueProtudo);
        }}
        defaultValue=""
        hiddens={[{ name: 'prod_descricao' }]}
        getValue={(value) => {
          if (value.prod_codigo !== null) {
            setValueProduto(value.prod_codigo);
          } else {
            setValueProduto(0);
          }
        }}
      />

      <ListTransfer
        search
        grid
        cells={cells}
        url="orgaos"
        label="orga_nome"
        unique="orga_codigo"
        leftTitle="Órgãos disponíveis"
        rightTitle="Órgãos selecionadas"
        onCallback={(value) => setOrgaos(value)}
        maxWidth={38}
        maxHeight={200}
        reset={isEmpty(orgaos)}
        showCount
      />

      <RadioGroup
        name="formato"
        label="Formato"
        options={[
          { label: 'PDF', value: 'pdf' },
          { label: 'Excel', value: 'xls' },
        ]}
        defaultValue="pdf"
        serialize={(value) => value}
        row
      />
    </Report>
  );
}

export default Reldespesaaquisicaocombustivel;
